import backgroundStyles from './Background.scss';
export var gradientToClassName = function (gradient) {
    return gradient === undefined ? '' : backgroundStyles["gradient-type-" + gradient];
};
export var rgba = function (hexColor, opacity) {
    if (opacity === void 0) { opacity = 1; }
    var r = 0, g = 0, b = 0;
    // #XXX
    if (hexColor.length === 4) {
        r = parseInt("" + hexColor[1] + hexColor[1], 16);
        g = parseInt("" + hexColor[2] + hexColor[2], 16);
        b = parseInt("" + hexColor[3] + hexColor[3], 16);
        // #XXXXXX
    }
    else if (hexColor.length === 7) {
        r = parseInt("" + hexColor[1] + hexColor[2], 16);
        g = parseInt("" + hexColor[3] + hexColor[4], 16);
        b = parseInt("" + hexColor[5] + hexColor[6], 16);
    }
    var a = Math.max(0, Math.min(1, opacity));
    return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
};
//# sourceMappingURL=utils.js.map